import { render } from "./AddReferentePage.vue?vue&type=template&id=3d2e3b0d"
import script from "./AddReferentePage.vue?vue&type=script&lang=js"
export * from "./AddReferentePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__